import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {request} from 'utils/request-axios';

export type ProfileSuccessResponse = Api.Response.Success<{next_url: string}>;

export const useAcceptPortalLogin = (): UseMutationResult<
    ProfileSuccessResponse,
    Error,
    {next: string; token: string}
> => {
    const locale = useLocale();

    return useMutation({
        mutationFn: (formData) =>
            request({
                formData,
                locale,
                method: 'POST',
                url: window.Urls.portal_send_link_callback_view(),
            }),
    });
};
